document.addEventListener("DOMContentLoaded", () => {

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const burger = document.querySelector(".js-burger");
  const menu   = document.querySelector(".js-header-nav");
  if (burger && menu) {
    burger.addEventListener("click", () => {
      const open = menu.classList.toggle("active");
      burger.classList.toggle("active", open);
      document.body.classList.toggle("locked", open);
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Search overlay ───────────────────────────────────────────────────────
  const openSearchBtn  = document.querySelector(".js-open-search");
  const closeSearchBtn = document.querySelector(".js-close-search");
  const searchOverlay  = document.querySelector(".js-search-overlay");
  if (openSearchBtn && closeSearchBtn && searchOverlay) {
    openSearchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      searchOverlay.classList.add("active");
      document.body.classList.add("locked");
      setTimeout(() => {
        const input = searchOverlay.querySelector("input");
        if (input) input.focus();
      }, 100);
    });
    closeSearchBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("active");
      document.body.classList.remove("locked");
    });
    searchOverlay.addEventListener("click", (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── FAQ accordion ─────────────────────────────────────────────────────────
  document.querySelectorAll(".js-faq-item").forEach((item) => {
    const trigger = item.querySelector(".js-faq-trigger");
    if (!trigger) return;
    trigger.addEventListener("click", () => {
      const open = !item.classList.contains("is-open");
      item.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  // ─── Back to top ─────────────────────────────────────────────────────────
  const backToTop = document.querySelector(".js-back-to-top");
  if (backToTop) {
    const toggle = () => backToTop.classList.toggle("is-visible", window.scrollY > 400);
    window.addEventListener("scroll", toggle, { passive: true });
    toggle();
    backToTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }



  // ─── TradingView widgets: load only when visible ─────────────────────────
  const loadTradingView = (node) => {
    if (!node || node.dataset.loaded) return;
    node.dataset.loaded = "1";
    const box = document.createElement("div");
    box.className = "tradingview-widget-container";
    box.style.height = "100%";
    box.style.width = "100%";
    const inner = document.createElement("div");
    inner.className = "tradingview-widget-container__widget";
    inner.style.height = "100%";
    inner.style.width = "100%";
    box.appendChild(inner);
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-" + node.dataset.tv + ".js";
    script.async = true;
    script.text = node.dataset.config || "{}";
    box.appendChild(script);
    node.appendChild(box);
    setTimeout(() => node.parentNode.classList.add("is-ready"), 1500);
  };
  const isHidden = (node) => !!node.closest("[hidden]");
  const tvNodes = document.querySelectorAll("[data-tv]");
  let tvObserver = null;
  if ("IntersectionObserver" in window) {
    tvObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isHidden(entry.target)) {
          loadTradingView(entry.target);
          tvObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: "300px 0px" });
    tvNodes.forEach((node) => tvObserver.observe(node));
  } else {
    tvNodes.forEach((node) => { if (!isHidden(node)) loadTradingView(node); });
  }

  // ─── Tabs (toolkit + market desk) ────────────────────────────────────────
  // Keep a tab group's own panels only: nested groups (calculator tabs
  // inside no outer group) never collide because each [data-tabs] scopes
  // its queries to direct children.
  document.querySelectorAll("[data-tabs]").forEach((group) => {
    const tabs = Array.from(group.querySelectorAll(':scope > [role="tablist"] > [role="tab"]'));
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute("aria-controls"));
        if (panel) panel.hidden = !on;
      });
      const panel = document.getElementById(tab.getAttribute("aria-controls"));
      if (panel) panel.querySelectorAll("[data-tv]").forEach(loadTradingView);
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener("click", () => select(tab, false));
      tab.addEventListener("keydown", (e) => {
        let next = null;
        if (e.key === "ArrowRight") next = tabs[(i + 1) % tabs.length];
        if (e.key === "ArrowLeft") next = tabs[(i + tabs.length - 1) % tabs.length];
        if (e.key === "Home") next = tabs[0];
        if (e.key === "End") next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          select(next, true);
        }
      });
    });
  });

  // ─── Reveal on scroll ────────────────────────────────────────────────────
  const reveals = document.querySelectorAll(".bz-reveal");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reveals.length && !reduceMotion && "IntersectionObserver" in window) {
    document.documentElement.classList.add("js-reveal");
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    reveals.forEach((node) => revealObserver.observe(node));
  }

});
